<template>
  <KkIconBase
    class="kk-icon"
    :class="size && `kk-icon--${size}`"
    :name="name"
  />
</template>

<script>
import KkIconBase from '../../KkIconBase';
import { kkCheckIcon } from '../../../libs/kkIconValidator';
import { defineComponent } from 'vue-demi';

export const KK_ICON_SIZE_LIST = ['2xs', 'xs', 'sm', 'md', 'lg', 'xl'];
export default defineComponent({
  name: 'KkIcon',
  components: {
    KkIconBase,
  },
  props: {
    name: {
      type: String,
      required: true,
      validator: (val) => kkCheckIcon(val),
    },
    size: {
      type: String,
      default: null,
      validator: (val) => !val || KK_ICON_SIZE_LIST.indexOf(val) !== -1,
    },
  },
});
</script>
